import { UserService } from '../../../service/UserService'
import TYPES from '../../../config/Types'
import { DependencyContainer } from '../../../config/DependencyContainer'

const userService = DependencyContainer.getContainer().get<UserService>(TYPES.UserService)

const userUtils = {
  get userService () { return userService }
}

export default userUtils
